import styles from './ModalTerms.module.css';
import { Markup } from 'interweave';
import Modal from 'react-responsive-modal';
import { Button } from '../../../../components/Button';

interface IModalTerms {
  modalTermsIsOpen: boolean;
  toggleModalTerms: () => void;
  clientTerms: any;
}

export function ModalTerms({
  modalTermsIsOpen,
  toggleModalTerms,
  clientTerms,
}: IModalTerms) {
  return (
    <Modal open={modalTermsIsOpen} onClose={toggleModalTerms}>
      <div className="contents-modal">
        <h1 className="title-modal">Termos de uso</h1>

        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 mb-12 mb-3">
            <Markup content={clientTerms?.htmlString} />
          </div>
        </div>
      </div>
      <div className={styles.contentBtn}>
        <Button text="Concordo" type="button" color="primary" isModal />
      </div>
    </Modal>
  );
}
